import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodOptionalId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyTradeNewRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/trades/new',
  validateSearch: z.object({
    labId: zodOptionalId,
  }),
}).lazy(() =>
  import('pages/pharmacy/Trades/PharmacyTradeNewPage/PharmacyTradeNewPage').then((d) => d.Route)
);
